export default __webpack_public_path__ + "assets/0f7a568f0d2e2fdb902e48fd82187a31.svg";